module.exports = __webpack_public_path__ + "img/微信图片_20251001102858_1951_207.eed18876.jpg";